// extracted by css-extract-rspack-plugin
export default {"glassColumn":"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-GlassColumn-GlassColumn-module__glassColumn-PHjOdr"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"glassColumn\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-GlassColumn-GlassColumn-module__glassColumn-PHjOdr\"}";
        // 1793875579153
        var cssReload = require("../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  